'use strict';

var _ = require('lodash');
var numeral = require('numeral');
var NumberFormattingFilter = function NumberFormattingFilter(FormattingConstants) {
  var defaultFormat = FormattingConstants.FORMATS.NUMBER;
  function formatNumber(value, format) {
    return numeral(value).format(format);
  }
  return function (value, formatName, multiply) {
    var format = FormattingConstants.FORMATS[formatName] || defaultFormat;
    if (_.isUndefined(value) || _.isNull(value) || _.isNumber(value) && !_.isFinite(value)) {
      return 'N/A';
    }
    if (!_.isNumber(value)) {
      return value;
    }
    if (_.includes(format, '%') && !multiply) {
      value = value / 100;
    }
    return formatNumber(value, format);
  };
};
NumberFormattingFilter.$inject = ['FormattingConstants'];
module.exports = NumberFormattingFilter;